import { multipleProtectedRouteBeforeLoad } from "@/components/utils/multipleProtectedRouteBeforeLoad";
import { protectedNoFreeRoute } from "@/lib/protectedNoFreeRoute";
import { protectedRoute } from "@/lib/protectedRoute";
import { TemplateCreate } from "@/pages/TemplateCreate";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/template/new")({
  component: TemplateCreate,
  beforeLoad: () =>
    multipleProtectedRouteBeforeLoad(
      () => protectedRoute({ location: window.location }),
      () => protectedNoFreeRoute()
    ),
});
